<ul class='ba-linklist my-3' aria-label='Ordner'>
<!--  POSTEINGANG-->
  <li>
    <a href="#" id="kpf-btn-tab-erhalten"
       class='ba-icon-inbox {{getFolderClassList(ordnerEnum.ERHALTEN)}}'
       (click)="onFolderSelected(ordnerEnum.ERHALTEN, $event)">{{ "mailbox.inbox" | i18next }}
      <span class='ms-auto'>&nbsp;{{ getNachrichtFolder(ordnerEnum.ERHALTEN)?.anzahlUngelesen }}
        <span class='sr-only'>&nbsp;{{ "mailbox.unread" | i18next }}</span>
      </span>
      @if (selectedFolder === ordnerEnum.ERHALTEN) {
        <span class='sr-only'>&nbsp;{{ "mailbox.current-selection" | i18next }}</span>
      }
    </a>
  </li>
<!--  GESENDET-->
  <li>
    <a href="#" id="kpf-btn-tab-gesendet" class='ba-icon-send-mail {{getFolderClassList(ordnerEnum.GESENDET)}}'
       (click)="onFolderSelected(ordnerEnum.GESENDET, $event)">{{ "mailbox.sent" | i18next }}
      @if (selectedFolder === ordnerEnum.GESENDET) {
        <span class='sr-only'>&nbsp;{{ "mailbox.current-selection" | i18next }}</span>
      }
    </a>
  </li>
  <!--  ENTWURF-->
  <li>
    <a href="#" id="kpf-btn-tab-entwurf" class='ba-icon-edit {{getFolderClassList(ordnerEnum.ENTWURF)}}'
       (click)="onFolderSelected(ordnerEnum.ENTWURF, $event)">{{ "mailbox.drafts" | i18next }}
      <span class='ms-auto'>&nbsp;{{ getNachrichtFolder(ordnerEnum.ENTWURF)?.anzahlGesamt }}
        <span class='sr-only'>&nbsp;{{ "mailbox.in-total" | i18next }}</span>
      </span>
      @if (selectedFolder === ordnerEnum.ENTWURF) {
        <span class='sr-only'>&nbsp;{{ "mailbox.current-selection" | i18next }}</span>
      }
    </a>
  </li>
  <!--  GELOESCHT-->
  <li>
    <a href="#" id="kpf-btn-tab-geloescht" class='ba-icon-trash {{getFolderClassList(ordnerEnum.GELOESCHT)}}'
       (click)="onFolderSelected(ordnerEnum.GELOESCHT, $event)">{{ "mailbox.deleted" | i18next }}
      @if (selectedFolder === ordnerEnum.GELOESCHT) {
        <span class='sr-only'>&nbsp;{{ "mailbox.current-selection" | i18next }}</span>
      }
    </a>
  </li>
</ul>
